<div *ngIf="loading">
  <div class="col-12 mb-4">
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!loading">
  <div class="col-12 d-none d-lg-block mb-2 mt-2 py-1" style="background-color: #EAE8F5; border-radius: 8px;"
    *ngIf="header">
    <div class="row">
      <div class="col-3 d-flex align-items-center justify-content-center">
        <!-- [ngClass]="{'col-lg-7': pricing, 'col-lg-7': !pricing}"-->
        <div class="col-12 pl-2 text-left subtitle-section">Concepto y descripción</div>
      </div>
      <div class="col-8 d-none d-lg-block">
        <!--[ngClass]="{'col-lg-5': pricing, 'col-lg-5': !pricing}"-->
        <div class="row"> 
          <div class="col-2 text-center subtitle-section" *ngIf="pricing">Fecha</div>
          <div class="col-2 text-left subtitle-section" *ngIf="pricing">Proveedor</div>
          <div class="col-1 text-right subtitle-section" [ngClass]="{'col-1': pricing, 'col-12': !pricing}">Cant.
          </div>
          <div class="col-2 text-right subtitle-section" *ngIf="pricing">Costo {{curr}}</div>
          <div class="col-2 text-right subtitle-section" *ngIf="pricing">Subtotal {{curr}}</div>
          <div class="col-1 text-right subtitle-section" *ngIf="pricing">Imp%</div>
          <div class="col-2 text-right subtitle-section" *ngIf="pricing">Total {{curr}}</div>
        </div>
      </div>
      <div class="col-12 col-lg-1 d-none d-lg-block">
        <div class="col-12"></div>
      </div>
    </div>
  </div>

  <div class="row" *ngFor="let item of items; let i = index">

    <div class="col-12">
      <app-detail-item-expenses [item]="item" [disableButton]="disableButton" (itemChange)="onItemChange(item, $event)"
        (remove)="onRemove(item)" [readOnly]="readOnly" [pricing]="pricing" [vendors]="vendors">
      </app-detail-item-expenses>
    </div>
  </div>

  <div class="row" *ngIf="!readOnly">
    <div class="col-4">
      <button class="btn btn-outline-manax p-1" type="button" (click)="addItem()">
        <i class="material-icons mr-1">add</i>
        Añadir línea
      </button>
    </div>
  </div>

  <div class="row" *ngIf="footer && pricing">
    <div class="col-md-12">
      <div class="row">
        <div class="col-12 col-md-11 text-center text-md-right px-sm-4">
          <div class="item-valor">
            <b>Subtotal:&nbsp;</b>{{totals.subtotal | money : { needSymbol:true } }},&nbsp;
            <b>Impuestos:&nbsp;</b>{{totals.tax | money : { needSymbol:true } }},&nbsp;
            <b>TOTAL:&nbsp;</b>{{totals.total | money : { needSymbol:true } }}
          </div>
        </div>
        <div class="d-none d-md-block col-md-1">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</div>